// extracted by mini-css-extract-plugin
export default {"pickerContainer":"CommentMenu-module__pickerContainer--gMn7v","backdrop":"CommentMenu-module__backdrop--ERNFY"};